<template>
  <div>
    <Navbar active="clubs" />
    <CrudList
      tableName="club"
      tableNamePlural="clubs"
      defaultSort="reg_num"
      queryParams="?join=church"
      :columns="columns"
      :dataModifier="dataModifier"
    />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import CrudList from "@/components/CrudList.vue";

export default {
  name: "ClubList",
  components: {
    Navbar,
    CrudList,
  },
  data() {
    return {
      columns: [
        {
          field: "reg_num",
          label: "Registration #",
          sortable: true,
          visible: true,
        },
        {
          field: "church_id",
          label: "Church",
          sortable: true,
          visible: false,
          type: "church",
          customSearch: (row, search) => {
            return row.church_id.id === parseInt(search);
          },
        },
        {
          field: "reg_date",
          label: "Registration Date",
          sortable: true,
          visible: true,
          customSort: (a, b, isAsc) => {
            var aDate = new Date(a.reg_date);
            var bDate = new Date(b.reg_date);
            if (isNaN(aDate)) {
              aDate = new Date("2200-01-01T00:00:00");
            }
            if (isNaN(bDate)) {
              bDate = new Date("2200-01-01T00:00:00");
            }
            if (isAsc) {
              return aDate - bDate;
            } else {
              return bDate - aDate;
            }
          },
        },
        {
          field: "name_zh",
          label: "Name (Chinese)",
          sortable: true,
          visible: true,
        },
        {
          field: "name_en",
          label: "Name (English)",
          sortable: true,
          visible: true,
        },
        { field: "phone", label: "Phone", sortable: false, visible: false },
        { field: "email", label: "Email", sortable: false, visible: false },
        {
          field: "existing",
          label: "Existing",
          sortable: true,
          visible: true,
          type: "boolean",
        },
        {
          field: "actions",
          label: "Actions",
          sortable: false,
          visible: true,
          searchable: false,
          width: "140px",
        },
      ],
    };
  },
  methods: {
    dataModifier(records) {
      return records;
    },
  },
};
</script>
